export function sanitizeUUID(input: string): string {
  return input.replace(/\-/g, '');
}
